import React, { useState, useEffect } from "react";
import { colors } from "../../../../../../themes/Colors";
import {
  BaseButtons,
  CheckInput,
  TextInputField,
  TextInputFieldArea,
} from "../../../../../common-components";
import ImageUploadAWS from "../../../../../user/components/image-upload/ImageUploadAWS";
import CatalogueListItem from "./catalogue-list-item/CatalogueListItem";
import CreateProductModal from "./create-product-modal/CreateProductModal";
import CatalogueCategory from "./catalogue-category/CatalogueCategory";

const validFileTypes = ["image/jpg", "image/jpeg", "image/png"];

const AgencyManagerPopUp = ({
  display,
  setSelectedAgency,
  selectedAgency,
  auth,
  setToastPop,
  setMessage,
  setLoading,
  loading,
  setPopUpTitle,
  setRefresh,
  refresh,
}) => {
  const [displayScreen, setDisplayScreen] = useState("profile");

  const [file, setFile] = useState(null);

  const [statusCheck, setStatusCheck] = useState(null);

  const [statusOption, setStatusOption] = useState(false);

  const [previewUrl, setPreviewUrl] = useState(null);

  const [logoLink, setLogoLink] = useState(null);

  const [imageLink, setImageLink] = useState(null);

  const [imageError, setImageError] = useState("");

  const [teamMembers, setTeamMembers] = useState(null);

  const [agencyCustomers, setAgencyCustomers] = useState(null);

  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customerTab, setCustomerTab] = useState("tasks");

  // this is the catalogue managemnt section
  const [catalogueScreenDisplay, setCatalogueScreenDisplay] =
    useState("products");
  const [searchCatelgoue, setSearchCatalogue] = useState("");
  const [search, setSearch] = useState("");

  const [productsArray, setProductsArray] = useState(null);
  const [categoyrArray, setCategoryArray] = useState(null);

  const [selectedProduct, setSelectedProduct] = useState(null);

  const [selectedIndex, setSelectedIndex] = useState(null);

  const handleFileChange = (e) => {
    // Uploaded file
    const file = e.target.files[0];
    // Changing file state
    setFile(file);
  };

  const fetchAgencyCustomers = async () => {
    setLoading(true);

    try {
      const customers = await fetch(
        "https://driverfrienddatabase-h2aa.onrender.com" +
          "/agency/getAgencyCustomers",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            userId: auth.userId,
            agencyId: selectedAgency._id,
          }),
        }
      );

      const responseData = await customers.json();

      if (responseData.success) {
        setRefresh(refresh ? false : true);
        if (
          Array.isArray(responseData.customers) &&
          responseData.customers.length
        ) {
          setAgencyCustomers(responseData.customers);
        }
      } else {
        setPopUpTitle("FAILURE");
        setToastPop(true);
        setMessage(responseData.message);
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
      setPopUpTitle("FAILURE");
      setToastPop(true);
      setMessage(
        "No network try again after connecting, if this persists please contact support"
      );
      setLoading(false);
    }
  };

  const EditAgency = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/agency/agencyEdit",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            userId: auth.userId,
            companyId: selectedAgency.companyId,
            documentId: selectedAgency._id,
            status: statusCheck,
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.success) {
        setToastPop(true);
        setMessage(respnseData.success);

        setPopUpTitle("SUCCESS");
        setSelectedAgency(null);
        setRefresh(refresh ? false : true);
        setLoading(false);
      } else {
        setPopUpTitle("FAILURE");
        setToastPop(true);
        setMessage(respnseData.message);
        setLoading(false);
      }
    } catch (err) {
      setPopUpTitle("FAILURE");
      setToastPop(true);
      setMessage(
        "No network try again after connecting, if ths persist please contact support"
      );
      setLoading(false);
    }
  };

  const getProducts = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://driverfrienddatabase-h2aa.onrender.com" +
          "/catalogue/getProducts",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            bussinessId: selectedAgency._id,
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.success) {
        setProductsArray(respnseData.products);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      console.log("error", err);
    }
  };

  const getCategories = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://driverfrienddatabase-h2aa.onrender.com" +
          "/catalogue/getCategories",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            bussinessId: selectedAgency._id,
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.success) {
        setCategoryArray(respnseData.categoryList);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      console.log("error", err);
    }
  };

  useEffect(() => {
    if (!file) {
      //   if (!sigfile) {
      //     return;
      //   }
      return;
    }
    const fileReader = new FileReader();
    fileReader.onload = () => {
      setPreviewUrl(fileReader.result);
    };
    fileReader.readAsDataURL(file);
  }, [file]);

  useEffect(() => {
    if (selectedAgency) {
      getProducts();
      getCategories();
      setStatusCheck(selectedAgency.accountStatus);
      setTeamMembers(selectedAgency.teamMembers[0]);
      fetchAgencyCustomers();
    } else {
      setStatusCheck(null);
      setTeamMembers(null);
      setAgencyCustomers(null);
      setDisplayScreen("profile");
    }
  }, [selectedAgency]);

  useEffect(() => {
    if (selectedCustomer) {
      console.log("check");
    }
  }, [selectedCustomer]);
  return (
    <div
      style={{
        position: "absolute",
        bottom: 0,
        backgroundColor: colors.white,
        height: display ? "100%" : 0,
        width: "100%",
        overflow: "hidden",
        transition: "all 0.28s",
        opacity: display ? 1 : 0,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div style={{ minHeight: 70 }}></div>
      {displayScreen === "profile" ? (
        <div style={{ flex: 1, display: "flex", overflowY: "scroll" }}>
          <div
            style={{
              flex: 0.5,

              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            <div
              style={{
                width: "90%",
                marginTop: 20,
                fontWeight: "bold",
                fontSize: 18,
                display: "flex",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  minWidth: 10,
                  minHeight: 10,
                  borderRadius: 100,
                  backgroundColor: colors.secondaryDarkBlue,
                  marginRight: 10,
                }}
              />
              BASIC INFORMATION
            </div>
            <div
              style={{
                display: "flex",
                width: "90%",

                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  flex: 0.3,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                  flexDirection: "column",
                }}
              >
                <div
                  style={{
                    minHeight: 200,
                    minWidth: 200,
                    backgroundColor: logoLink
                      ? logoLink
                      : previewUrl
                      ? null
                      : "#00000050",
                    borderRadius: 8,
                    marginTop: 30,
                    marginRight: 20,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img
                    alt="Preview"
                    src={logoLink ? logoLink : previewUrl ? previewUrl : null}
                    style={{ maxHeight: 150, maxWidth: 150 }}
                  />
                </div>
              </div>
              <div
                style={{
                  flex: 0.7,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  height: "100%",
                }}
              >
                <TextInputField
                  labelTitle={"COMPANY NAME"}
                  mini={true}
                  width={"100%"}
                  size={"90%"}
                  value={
                    selectedAgency ? selectedAgency.companyName : "loading"
                  }
                  readOnly={true}
                />
                {selectedAgency ? (
                  selectedAgency.companySlogan !== "" ? (
                    <TextInputField
                      labelTitle={"COMPANY SLOGAN"}
                      mini={true}
                      width={"100%"}
                      size={"90%"}
                      value={
                        selectedAgency
                          ? selectedAgency.companySlogan
                          : "loading"
                      }
                      readOnly={true}
                    />
                  ) : null
                ) : null}
              </div>
            </div>

            <TextInputFieldArea
              labelTitle={"COMPANY DESCRIPTION"}
              height={150}
              mini={true}
              width={"90%"}
              size={"93%"}
              value={
                selectedAgency ? selectedAgency.companyDescription : "loading"
              }
              readOnly={true}
            />
            <TextInputField
              labelTitle={"CONTACT PERSON ( READ ONLY )"}
              mini={true}
              width={"93%"}
              size={"90%"}
              readOnly={true}
              value={
                selectedAgency ? selectedAgency.companyContactName : "loading"
              }
            />
            <TextInputField
              labelTitle={"CONTACT NUMBER"}
              mini={true}
              width={"93%"}
              size={"90%"}
              value={
                selectedAgency ? selectedAgency.companyContactNumber : "loading"
              }
              readOnly={true}
            />
            <TextInputField
              labelTitle={"CONTACT EMAIL"}
              mini={true}
              width={"93%"}
              size={"90%"}
              value={selectedAgency ? selectedAgency.companyEmail : "loading"}
            />
          </div>
          <div
            style={{
              flex: 0.5,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            <div
              style={{
                width: "90%",
                marginTop: 20,
                fontWeight: "bold",
                fontSize: 18,
                display: "flex",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  minWidth: 10,
                  minHeight: 10,
                  borderRadius: 100,
                  backgroundColor: colors.secondaryDarkBlue,
                  marginRight: 10,
                }}
              />
              IMPORTANT INFORMATION:
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                alignItems: "center",
                position: "relative",
              }}
            >
              <div
                style={{
                  width: "90%",
                  fontWeight: "bold",
                  fontSize: 12,
                  marginTop: 10,
                  marginBottom: 5,
                }}
              >
                <div style={{ marginLeft: 20 }}> ACCOUNT STATUS</div>
              </div>

              <BaseButtons
                label={statusCheck ? statusCheck : "loading"}
                borderRadius={8}
                width={"90%"}
                backgroundColor={colors.greenLight}
                onClick={() => setStatusOption(true)}
              />
              <div
                style={{
                  width: "100%",
                  height: statusOption ? 200 : 0,
                  backgroundColor: colors.white,
                  overflow: "hidden",
                  position: "absolute",
                  top: 0,
                  zIndex: 20,
                  WebkitBoxShadow: statusOption
                    ? "0px 0px 7px 2px #00000050"
                    : "0px 0px 0px 0px #00000050",
                  borderRadius: 8,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-evenly",
                  alignItems: "center",
                }}
              >
                <BaseButtons
                  label={"APPROVED"}
                  borderRadius={8}
                  width={"90%"}
                  backgroundColor={colors.greenLight}
                  onClick={() => {
                    setStatusCheck("APPROVED");
                    setStatusOption(false);
                  }}
                />
                <BaseButtons
                  label={"INACTIVE"}
                  borderRadius={8}
                  width={"90%"}
                  backgroundColor={colors.greenLight}
                  onClick={() => {
                    setStatusCheck("INACTIVE");
                    setStatusOption(false);
                  }}
                />
                <BaseButtons
                  label={"PENDING APPROVAL"}
                  borderRadius={8}
                  width={"90%"}
                  backgroundColor={colors.greenLight}
                  onClick={() => {
                    setStatusCheck("PENDING APPROVAL");
                    setStatusOption(false);
                  }}
                />
              </div>
            </div>
            <TextInputField
              labelTitle={"WEBSITE"}
              mini={true}
              width={"93%"}
              size={"90%"}
              value={selectedAgency ? selectedAgency.companyWebsite : "loading"}
              readOnly={true}
            />
            <TextInputFieldArea
              labelTitle={"COMPANY ADDRESS"}
              height={100}
              mini={true}
              width={"90%"}
              size={"93%"}
              value={selectedAgency ? selectedAgency.companyAddress : "loading"}
              readOnly={true}
            />

            <div
              style={{
                width: "90%",
                marginTop: 30,
                fontWeight: "bold",
                fontSize: 18,
                display: "flex",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  minWidth: 10,
                  minHeight: 10,
                  borderRadius: 100,
                  backgroundColor: colors.secondaryDarkBlue,
                  marginRight: 10,
                }}
              />
              SERVICES YOU OFFER:
            </div>
            <div
              style={{
                minHeight: 270,
                maxHeight: 270,
                width: "100%",
                flexWrap: "wrap",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {selectedAgency
                ? selectedAgency.companyServices.map((service, index) => {
                    return (
                      <div key={index} style={{ width: "45%", maxHeight: 40 }}>
                        <CheckInput
                          label={service.serviceType}
                          selected={service.value}
                        />
                      </div>
                    );
                  })
                : "loading"}
            </div>

            <div style={{ minHeight: 20 }} />
            <BaseButtons
              label={"VIEW TERMS AND CONDITIONS"}
              borderRadius={8}
              backgroundColor={colors.secondaryDarkBlue}
              width={"90%"}
            />
            <div style={{ minHeight: 20 }} />
          </div>
        </div>
      ) : null}
      {displayScreen === "team" ? (
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            overflowY: "scroll",
          }}
        >
          <div
            style={{
              width: "100%",
              marginTop: 20,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div style={{ width: "95%", fontWeight: "bold", fontSize: 18 }}>
              ADMIN USERS
            </div>
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
              marginTop: 20,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                minHeight: 90,
                width: 250,
                backgroundColor: colors.white,
                borderStyle: "solid",
                borderWidth: 3,
                borderColor: colors.secondaryDarkBlue,
                borderRadius: 8,
                justifyContent: "flex-start",
                alignItems: "center",
                WebkitBoxShadow: "-5px 5px 15px -1px #00000070",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  width: "90%",
                  marginBottom: 10,
                  marginTop: 10,
                  fontWeight: "bold",
                  fontSize: 14,
                }}
              >
                ADMIN 1
              </div>
              <div style={{ width: "90%", textAlign: "center" }}>
                {teamMembers
                  ? teamMembers.admin1.name.toLocaleUpperCase()
                  : "loading"}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                minHeight: 90,
                width: 250,
                backgroundColor: teamMembers
                  ? teamMembers.admin2.name === "none"
                    ? null
                    : colors.white
                  : colors.white,
                borderStyle: teamMembers
                  ? teamMembers.admin2.name === "none"
                    ? "none"
                    : "solid"
                  : "solid",
                borderWidth: 3,
                borderColor: teamMembers
                  ? teamMembers.admin2.name === "none"
                    ? null
                    : colors.secondaryDarkBlue
                  : colors.secondaryDarkBlue,
                borderRadius: 8,
                justifyContent: "flex-start",
                alignItems: "center",
                WebkitBoxShadow: teamMembers
                  ? teamMembers.admin2.name === "none"
                    ? null
                    : "-5px 5px 15px -1px #00000070"
                  : "-5px 5px 15px -1px #00000070",
                overflow: teamMembers
                  ? teamMembers.admin2.name === "none"
                    ? null
                    : "hidden"
                  : "hidden",
                //   marginLeft: 20,
              }}
            >
              <div
                style={{
                  width: "90%",
                  marginBottom: 10,
                  marginTop: 10,
                  fontWeight: "bold",
                  fontSize: 14,
                }}
              >
                ADMIN 2
              </div>
              <div
                style={{
                  textAlign: "center",
                  width: "90%",
                  display: "flex",
                  justifyContent: teamMembers
                    ? teamMembers.admin2.name === "none"
                      ? "center"
                      : "flex-start"
                    : "flex-start",
                }}
              >
                {teamMembers
                  ? teamMembers.admin2.name.toLocaleUpperCase()
                  : "loading"}
              </div>
            </div>
          </div>
          <div
            style={{
              width: "100%",
              marginTop: 20,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div style={{ width: "95%", fontWeight: "bold", fontSize: 18 }}>
              TEAM LEADERS
            </div>
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
              marginTop: 20,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                minHeight: 90,
                width: 250,
                backgroundColor: teamMembers
                  ? teamMembers.finesTeamLeader.name === "none"
                    ? null
                    : colors.white
                  : colors.white,
                borderStyle: teamMembers
                  ? teamMembers.finesTeamLeader.name === "none"
                    ? "none"
                    : "solid"
                  : "solid",
                borderWidth: 3,
                borderColor: teamMembers
                  ? teamMembers.finesTeamLeader.name === "none"
                    ? null
                    : colors.secondaryDarkBlue
                  : colors.secondaryDarkBlue,
                borderRadius: 8,
                justifyContent: "flex-start",
                alignItems: "center",
                WebkitBoxShadow: teamMembers
                  ? teamMembers.finesTeamLeader.name === "none"
                    ? null
                    : "-5px 5px 15px -1px #00000070"
                  : "-5px 5px 15px -1px #00000070",
                overflow: teamMembers
                  ? teamMembers.finesTeamLeader.name === "none"
                    ? null
                    : "hidden"
                  : "hidden",
                marginLeft: 20,
              }}
            >
              <div
                style={{
                  width: "90%",
                  marginBottom: 10,
                  marginTop: 10,
                  fontWeight: "bold",
                  fontSize: 14,
                }}
              >
                FINES TEAM LEADER
              </div>
              <div
                style={{
                  textAlign: "center",
                  width: "90%",
                  display: "flex",
                  justifyContent: teamMembers
                    ? teamMembers.finesTeamLeader.name === "none"
                      ? "center"
                      : "flex-start"
                    : "flex-start",
                }}
              >
                {teamMembers
                  ? teamMembers.finesTeamLeader.name.toLocaleUpperCase()
                  : "loading"}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                minHeight: 90,
                width: 250,
                backgroundColor: teamMembers
                  ? teamMembers.liscensingTeamLeader.name === "none"
                    ? null
                    : colors.white
                  : colors.white,
                borderStyle: teamMembers
                  ? teamMembers.liscensingTeamLeader.name === "none"
                    ? "none"
                    : "solid"
                  : "solid",
                borderWidth: 3,
                borderColor: teamMembers
                  ? teamMembers.liscensingTeamLeader.name === "none"
                    ? null
                    : colors.secondaryDarkBlue
                  : colors.secondaryDarkBlue,
                borderRadius: 8,
                justifyContent: "flex-start",
                alignItems: "center",
                WebkitBoxShadow: teamMembers
                  ? teamMembers.liscensingTeamLeader.name === "none"
                    ? null
                    : "-5px 5px 15px -1px #00000070"
                  : "-5px 5px 15px -1px #00000070",
                overflow: teamMembers
                  ? teamMembers.liscensingTeamLeader.name === "none"
                    ? null
                    : "hidden"
                  : "hidden",
                marginLeft: 20,
              }}
            >
              <div
                style={{
                  width: "90%",
                  marginBottom: 10,
                  marginTop: 10,
                  fontWeight: "bold",
                  fontSize: 14,
                }}
              >
                LICENSING TEAM LEADER
              </div>
              <div
                style={{
                  textAlign: "center",
                  width: "90%",
                  display: "flex",
                  justifyContent: teamMembers
                    ? teamMembers.liscensingTeamLeader.name === "none"
                      ? "center"
                      : "flex-start"
                    : "flex-start",
                }}
              >
                {teamMembers
                  ? teamMembers.liscensingTeamLeader.name.toLocaleUpperCase()
                  : "loading"}
              </div>
            </div>
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
              marginTop: 20,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                minHeight: 90,
                width: 250,
                backgroundColor: teamMembers
                  ? teamMembers.vaulationTeamLeader.name === "none"
                    ? null
                    : colors.white
                  : colors.white,
                borderStyle: teamMembers
                  ? teamMembers.vaulationTeamLeader.name === "none"
                    ? "none"
                    : "solid"
                  : "solid",
                borderWidth: 3,
                borderColor: teamMembers
                  ? teamMembers.vaulationTeamLeader.name === "none"
                    ? null
                    : colors.secondaryDarkBlue
                  : colors.secondaryDarkBlue,
                borderRadius: 8,
                justifyContent: "flex-start",
                alignItems: "center",
                WebkitBoxShadow: teamMembers
                  ? teamMembers.vaulationTeamLeader.name === "none"
                    ? null
                    : "-5px 5px 15px -1px #00000070"
                  : "-5px 5px 15px -1px #00000070",
                overflow: teamMembers
                  ? teamMembers.vaulationTeamLeader.name === "none"
                    ? null
                    : "hidden"
                  : "hidden",
                marginLeft: 20,
              }}
            >
              <div
                style={{
                  width: "90%",
                  marginBottom: 10,
                  marginTop: 10,
                  fontWeight: "bold",
                  fontSize: 14,
                }}
              >
                VALUATION TEAM LEADER
              </div>
              <div
                style={{
                  textAlign: "center",
                  width: "90%",
                  display: "flex",
                  justifyContent: teamMembers
                    ? teamMembers.vaulationTeamLeader.name === "none"
                      ? "center"
                      : "flex-start"
                    : "flex-start",
                }}
              >
                {teamMembers
                  ? teamMembers.vaulationTeamLeader.name.toLocaleUpperCase()
                  : "loading"}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                minHeight: 90,
                width: 250,
                backgroundColor: teamMembers
                  ? teamMembers.salesTeamLeader.name === "none"
                    ? null
                    : colors.white
                  : colors.white,
                borderStyle: teamMembers
                  ? teamMembers.salesTeamLeader.name === "none"
                    ? "none"
                    : "solid"
                  : "solid",
                borderWidth: 3,
                borderColor: teamMembers
                  ? teamMembers.salesTeamLeader.name === "none"
                    ? null
                    : colors.secondaryDarkBlue
                  : colors.secondaryDarkBlue,
                borderRadius: 8,
                justifyContent: "flex-start",
                alignItems: "center",
                WebkitBoxShadow: teamMembers
                  ? teamMembers.salesTeamLeader.name === "none"
                    ? null
                    : "-5px 5px 15px -1px #00000070"
                  : "-5px 5px 15px -1px #00000070",
                overflow: teamMembers
                  ? teamMembers.salesTeamLeader.name === "none"
                    ? null
                    : "hidden"
                  : "hidden",
                marginLeft: 20,
              }}
            >
              <div
                style={{
                  width: "90%",
                  marginBottom: 10,
                  marginTop: 10,
                  fontWeight: "bold",
                  fontSize: 14,
                }}
              >
                SALES TEAM LEADER
              </div>
              <div
                style={{
                  textAlign: "center",
                  width: "90%",
                  display: "flex",
                  justifyContent: teamMembers
                    ? teamMembers.salesTeamLeader.name === "none"
                      ? "center"
                      : "flex-start"
                    : "flex-start",
                }}
              >
                {teamMembers
                  ? teamMembers.salesTeamLeader.name.toLocaleUpperCase()
                  : "loading"}
              </div>
            </div>
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
              marginTop: 20,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                minHeight: 90,
                width: 250,
                backgroundColor: teamMembers
                  ? teamMembers.autoFitmentTeamLeader.name === "none"
                    ? null
                    : colors.white
                  : colors.white,
                borderStyle: teamMembers
                  ? teamMembers.autoFitmentTeamLeader.name === "none"
                    ? "none"
                    : "solid"
                  : "solid",
                borderWidth: 3,
                borderColor: teamMembers
                  ? teamMembers.autoFitmentTeamLeader.name === "none"
                    ? null
                    : colors.secondaryDarkBlue
                  : colors.secondaryDarkBlue,
                borderRadius: 8,
                justifyContent: "flex-start",
                alignItems: "center",
                WebkitBoxShadow: teamMembers
                  ? teamMembers.autoFitmentTeamLeader.name === "none"
                    ? null
                    : "-5px 5px 15px -1px #00000070"
                  : "-5px 5px 15px -1px #00000070",
                overflow: teamMembers
                  ? teamMembers.autoFitmentTeamLeader.name === "none"
                    ? null
                    : "hidden"
                  : "hidden",
                marginLeft: 20,
              }}
            >
              <div
                style={{
                  width: "90%",
                  marginBottom: 10,
                  marginTop: 10,
                  fontWeight: "bold",
                  fontSize: 14,
                }}
              >
                AUTO-FITMENT TEAM LEADER
              </div>
              <div
                style={{
                  textAlign: "center",
                  width: "90%",
                  display: "flex",
                  justifyContent: teamMembers
                    ? teamMembers.autoFitmentTeamLeader.name === "none"
                      ? "center"
                      : "flex-start"
                    : "flex-start",
                }}
              >
                {teamMembers
                  ? teamMembers.autoFitmentTeamLeader.name.toLocaleUpperCase()
                  : "loading"}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                minHeight: 90,
                width: 250,
                backgroundColor: teamMembers
                  ? teamMembers.servicesTeamLeader.name === "none"
                    ? null
                    : colors.white
                  : colors.white,
                borderStyle: teamMembers
                  ? teamMembers.servicesTeamLeader.name === "none"
                    ? "none"
                    : "solid"
                  : "solid",
                borderWidth: 3,
                borderColor: teamMembers
                  ? teamMembers.servicesTeamLeader.name === "none"
                    ? null
                    : colors.secondaryDarkBlue
                  : colors.secondaryDarkBlue,
                borderRadius: 8,
                justifyContent: "flex-start",
                alignItems: "center",
                WebkitBoxShadow: teamMembers
                  ? teamMembers.servicesTeamLeader.name === "none"
                    ? null
                    : "-5px 5px 15px -1px #00000070"
                  : "-5px 5px 15px -1px #00000070",
                overflow: teamMembers
                  ? teamMembers.servicesTeamLeader.name === "none"
                    ? null
                    : "hidden"
                  : "hidden",
                marginLeft: 20,
              }}
            >
              <div
                style={{
                  width: "90%",
                  marginBottom: 10,
                  marginTop: 10,
                  fontWeight: "bold",
                  fontSize: 14,
                }}
              >
                SERVICES TEAM LEADER
              </div>
              <div
                style={{
                  textAlign: "center",
                  width: "90%",
                  display: "flex",
                  justifyContent: teamMembers
                    ? teamMembers.servicesTeamLeader.name === "none"
                      ? "center"
                      : "flex-start"
                    : "flex-start",
                }}
              >
                {teamMembers
                  ? teamMembers.servicesTeamLeader.name.toLocaleUpperCase()
                  : "loading"}
              </div>
            </div>
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
              marginTop: 20,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                minHeight: 90,
                width: 250,
                backgroundColor: teamMembers
                  ? teamMembers.sparesTeamLeader.name === "none"
                    ? null
                    : colors.white
                  : colors.white,
                borderStyle: teamMembers
                  ? teamMembers.sparesTeamLeader.name === "none"
                    ? "none"
                    : "solid"
                  : "solid",
                borderWidth: 3,
                borderColor: teamMembers
                  ? teamMembers.sparesTeamLeader.name === "none"
                    ? null
                    : colors.secondaryDarkBlue
                  : colors.secondaryDarkBlue,
                borderRadius: 8,
                justifyContent: "flex-start",
                alignItems: "center",
                WebkitBoxShadow: teamMembers
                  ? teamMembers.sparesTeamLeader.name === "none"
                    ? null
                    : "-5px 5px 15px -1px #00000070"
                  : "-5px 5px 15px -1px #00000070",
                overflow: teamMembers
                  ? teamMembers.sparesTeamLeader.name === "none"
                    ? null
                    : "hidden"
                  : "hidden",
                marginLeft: 20,
              }}
            >
              <div
                style={{
                  width: "90%",
                  marginBottom: 10,
                  marginTop: 10,
                  fontWeight: "bold",
                  fontSize: 14,
                }}
              >
                SPARE TEAM LEADER
              </div>
              <div
                style={{
                  textAlign: "center",
                  width: "90%",
                  display: "flex",
                  justifyContent: teamMembers
                    ? teamMembers.sparesTeamLeader.name === "none"
                      ? "center"
                      : "flex-start"
                    : "flex-start",
                }}
              >
                {teamMembers
                  ? teamMembers.sparesTeamLeader.name.toLocaleUpperCase()
                  : "loading"}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                minHeight: 90,
                width: 250,
                backgroundColor: teamMembers
                  ? teamMembers.towingTeamLeader.name === "none"
                    ? null
                    : colors.white
                  : colors.white,
                borderStyle: teamMembers
                  ? teamMembers.towingTeamLeader.name === "none"
                    ? "none"
                    : "solid"
                  : "solid",
                borderWidth: 3,
                borderColor: teamMembers
                  ? teamMembers.towingTeamLeader.name === "none"
                    ? null
                    : colors.secondaryDarkBlue
                  : colors.secondaryDarkBlue,
                borderRadius: 8,
                justifyContent: "flex-start",
                alignItems: "center",
                WebkitBoxShadow: teamMembers
                  ? teamMembers.towingTeamLeader.name === "none"
                    ? null
                    : "-5px 5px 15px -1px #00000070"
                  : "-5px 5px 15px -1px #00000070",
                overflow: teamMembers
                  ? teamMembers.towingTeamLeader.name === "none"
                    ? null
                    : "hidden"
                  : "hidden",
                marginLeft: 20,
              }}
            >
              <div
                style={{
                  width: "90%",
                  marginBottom: 10,
                  marginTop: 10,
                  fontWeight: "bold",
                  fontSize: 14,
                }}
              >
                TOWING TEAM LEADER
              </div>
              <div
                style={{
                  textAlign: "center",
                  width: "90%",
                  display: "flex",
                  justifyContent: teamMembers
                    ? teamMembers.towingTeamLeader.name === "none"
                      ? "center"
                      : "flex-start"
                    : "flex-start",
                }}
              >
                {teamMembers
                  ? teamMembers.towingTeamLeader.name.toLocaleUpperCase()
                  : "loading"}
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {displayScreen === "customers" ? (
        <div style={{ flex: 1, display: "flex", overflowY: "scroll" }}>
          <div
            style={{
              flex: 0.4,

              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            <div
              style={{
                width: "90%",
                marginTop: 20,
                fontWeight: "bold",
                fontSize: 18,
                display: "flex",
                alignItems: "center",
              }}
            >
              CUSTOMERS
            </div>
            <div
              style={{
                display: "flex",
                width: "90%",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              {agencyCustomers !== null
                ? agencyCustomers.map((customer, index) => {
                    return (
                      <div
                        onClick={() => setSelectedCustomer(customer)}
                        key={index}
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            minHeight: 60,
                            width: "95%",
                            borderStyle: selectedCustomer
                              ? selectedCustomer._id === customer._id
                                ? "none"
                                : "solid"
                              : "solid",
                            marginTop: 10,
                            display: "flex",
                            backgroundColor: selectedCustomer
                              ? selectedCustomer._id === customer._id
                                ? colors.greenLight
                                : colors.white
                              : colors.white,
                            borderRadius: 4,
                            padding: 10,
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-start",
                              alignItems: "center",
                              marginRight: 10,
                              marginLeft: 10,
                              color: selectedCustomer
                                ? selectedCustomer._id === customer._id
                                  ? colors.white
                                  : null
                                : null,
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <div
                              style={{
                                // marginLeft: 10,
                                marginBottom: 4,
                                fontSize: 12,
                                fontWeight: "bold",
                                marginTop: 10,
                                width: "100%",
                              }}
                            >
                              NAME
                            </div>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                minWidth: 100,
                              }}
                            >
                              {customer.firstName + " " + customer.lastName}
                            </div>
                          </div>

                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-start",
                              alignItems: "center",
                              // flex: 0.15,
                              color: selectedCustomer
                                ? selectedCustomer._id === customer._id
                                  ? colors.white
                                  : null
                                : null,
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <div
                              style={{
                                // marginLeft: 10,
                                marginBottom: 4,
                                fontSize: 12,
                                fontWeight: "bold",
                                marginTop: 10,
                                width: "100%",
                              }}
                            >
                              ID NUMBER
                            </div>
                            <div>{customer.idDoc}</div>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-start",
                              alignItems: "center",
                              // flex: 0.15,
                              color: selectedCustomer
                                ? selectedCustomer._id === customer._id
                                  ? colors.white
                                  : null
                                : null,
                              display: "flex",
                              flexDirection: "column",
                              marginLeft: 20,
                            }}
                          >
                            <div
                              style={{
                                // marginLeft: 10,
                                marginBottom: 4,
                                fontSize: 12,
                                fontWeight: "bold",
                                marginTop: 10,
                                width: "100%",
                              }}
                            >
                              ADDRESS
                            </div>
                            <div style={{ fontSize: 14 }}>
                              {customer.address}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                : null}
            </div>
          </div>
          <div
            style={{
              flex: 0.6,

              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "flex-start",
              backgroundColor: colors.white,
              borderLeftStyle: "solid",
              borderLeftColor: "#00000030",
            }}
          >
            {selectedCustomer ? (
              <div
                style={{
                  width: "100%",
                  minHeight: 50,
                  backgroundColor: colors.greenLight,
                  display: "flex",
                }}
              >
                <BaseButtons
                  label={"TASKS"}
                  height={"100%"}
                  width={"50%"}
                  backgroundColor={colors.greenLight}
                />
                <BaseButtons
                  label={"VEHICLES"}
                  height={"100%"}
                  width={"50%"}
                  backgroundColor={colors.greenDark}
                />
              </div>
            ) : (
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: 20,
                  marginTop: 20,
                  color: colors.white,
                }}
              >
                PLEASE SELECT CUSTOMER TO VIEW DETAILS
              </div>
            )}
          </div>
        </div>
      ) : null}
      {displayScreen === "vehicles" ? (
        <div style={{ flex: 1, display: "flex", overflowY: "scroll" }}>
          <div
            style={{
              flex: 1,

              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            <div
              style={{
                width: "90%",
                marginTop: 20,
                fontWeight: "bold",
                fontSize: 18,
                display: "flex",
                alignItems: "center",
                height: 50,
              }}
            >
              COMPANY VEHICLE
              <div style={{ flex: 1 }} />
              <div
                style={{
                  width: 300,
                  minHeight: 50,
                  backgroundColor: colors.greenLight,
                  display: "flex",
                }}
              >
                <BaseButtons
                  label={"FOR SALE"}
                  height={50}
                  width={"50%"}
                  backgroundColor={colors.greenLight}
                />
                <BaseButtons
                  label={"DRIVEN"}
                  height={50}
                  width={"50%"}
                  backgroundColor={colors.greenDark}
                />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                width: "90%",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              {/* {agencyCustomers !== null
                ? agencyCustomers.map((customer, index) => {
                    return (
                      <div
                        onClick={() => setSelectedCustomer(customer)}
                        key={index}
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            minHeight: 60,
                            width: "95%",
                            borderStyle: selectedCustomer
                              ? selectedCustomer._id === customer._id
                                ? "none"
                                : "solid"
                              : "solid",
                            marginTop: 10,
                            display: "flex",
                            backgroundColor: selectedCustomer
                              ? selectedCustomer._id === customer._id
                                ? colors.greenLight
                                : colors.white
                              : colors.white,
                            borderRadius: 4,
                            padding: 10,
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-start",
                              alignItems: "center",
                              marginRight: 10,
                              marginLeft: 10,
                              color: selectedCustomer
                                ? selectedCustomer._id === customer._id
                                  ? colors.white
                                  : null
                                : null,
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <div
                              style={{
                                // marginLeft: 10,
                                marginBottom: 4,
                                fontSize: 12,
                                fontWeight: "bold",
                                marginTop: 10,
                                width: "100%",
                              }}
                            >
                              NAME
                            </div>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                minWidth: 100,
                              }}
                            >
                              {customer.firstName + " " + customer.lastName}
                            </div>
                          </div>

                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-start",
                              alignItems: "center",
                              // flex: 0.15,
                              color: selectedCustomer
                                ? selectedCustomer._id === customer._id
                                  ? colors.white
                                  : null
                                : null,
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <div
                              style={{
                                // marginLeft: 10,
                                marginBottom: 4,
                                fontSize: 12,
                                fontWeight: "bold",
                                marginTop: 10,
                                width: "100%",
                              }}
                            >
                              ID NUMBER
                            </div>
                            <div>{customer.idDoc}</div>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-start",
                              alignItems: "center",
                              // flex: 0.15,
                              color: selectedCustomer
                                ? selectedCustomer._id === customer._id
                                  ? colors.white
                                  : null
                                : null,
                              display: "flex",
                              flexDirection: "column",
                              marginLeft: 20,
                            }}
                          >
                            <div
                              style={{
                                // marginLeft: 10,
                                marginBottom: 4,
                                fontSize: 12,
                                fontWeight: "bold",
                                marginTop: 10,
                                width: "100%",
                              }}
                            >
                              ADDRESS
                            </div>
                            <div style={{ fontSize: 14 }}>
                              {customer.address}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                : null} */}
            </div>
          </div>
        </div>
      ) : null}
      {displayScreen === "catalogue" ? (
        <div style={{ flex: 1, display: "flex", overflowY: "scroll" }}>
          <div
            style={{
              flex: 1,

              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            <div
              style={{
                width: "100%",
                // marginTop: 20,
                fontWeight: "bold",
                fontSize: 18,
                display: "flex",
                alignItems: "center",
                height: 50,
              }}
            >
              <div style={{ minWidth: 10 }} />
              <TextInputField
                mini={true}
                height={25}
                marginTop={-4}
                value={searchCatelgoue}
                onChange={(e) => setSearchCatalogue(e.target.value)}
              />
              <div style={{ minWidth: 10 }} />
              <BaseButtons
                label={"CLEAR"}
                height={39}
                width={100}
                borderRadius={4}
                backgroundColor={colors.orangeDark}
                onClick={() => {
                  setSearch("");
                  setSearchCatalogue("");
                }}
              />
              <div style={{ minWidth: 10 }} />
              <BaseButtons
                label={"SEARCH"}
                height={39}
                width={100}
                borderRadius={4}
                backgroundColor={colors.greenLight}
                onClick={() => {
                  setSearchCatalogue(search);
                }}
              />
              <div style={{ flex: 1 }} />
              <div
                style={{
                  width: 300,
                  minHeight: 50,
                  backgroundColor: colors.greenLight,
                  display: "flex",
                }}
              >
                <BaseButtons
                  label={"CATEGORIES"}
                  height={50}
                  width={"50%"}
                  backgroundColor={
                    catalogueScreenDisplay === "catagories"
                      ? colors.greenLight
                      : colors.greenDark
                  }
                  onClick={() => setCatalogueScreenDisplay("catagories")}
                />
                <BaseButtons
                  label={"PRODUCTS"}
                  height={50}
                  width={"50%"}
                  backgroundColor={
                    catalogueScreenDisplay === "products"
                      ? colors.greenLight
                      : colors.greenDark
                  }
                  onClick={() => setCatalogueScreenDisplay("products")}
                />
              </div>
            </div>
            {/* catalgue header list view */}
            {catalogueScreenDisplay === "catagories" && categoyrArray ? null : (
              <div
                style={{
                  width: "100%",
                  minHeight: 40,
                  backgroundColor: colors.secondaryDarkBlue,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div style={{ minWidth: 40, maxWidth: 40 }}></div>
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: 10,
                    color: colors.white,
                    flex: 0.2,
                  }}
                >
                  <div style={{ marginLeft: 10 }}> Product Name</div>
                </div>
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: 10,
                    color: colors.white,
                    flex: 0.2,
                  }}
                >
                  Category
                </div>
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: 10,
                    color: colors.white,
                    flex: 0.2,
                  }}
                >
                  Price
                </div>
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: 10,
                    color: colors.white,
                    flex: 0.2,
                  }}
                >
                  Created By
                </div>
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: 10,
                    color: colors.white,
                    flex: 0.15,
                  }}
                >
                  Date Created
                </div>
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: 10,
                    color: colors.white,
                    flex: 0.1,
                    // display: "flex",
                    // justifyContent: "center",
                    // alignItems: "center",
                  }}
                >
                  Status
                </div>
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: 10,
                    color: colors.white,
                    flex: 0.15,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  ACTIONS
                </div>
              </div>
            )}
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              {catalogueScreenDisplay === "products" && productsArray
                ? productsArray.map((item, index) => {
                    return item.productName
                      .toLowerCase()
                      .match(searchCatelgoue) ? (
                      <div
                        key={index}
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          minHeight: 45,
                        }}
                      >
                        <CatalogueListItem
                          productName={item.productName}
                          imageUrl={item.imageId}
                          category={item.category}
                          price={item.price}
                          createdBy={item.createdBy}
                          dateCreated={item.createdOn}
                          onViewClick={() => setSelectedProduct(item)}
                        />
                      </div>
                    ) : null;
                  })
                : null}
              {catalogueScreenDisplay === "catagories" && categoyrArray ? (
                <div style={{ minHeight: 10 }} />
              ) : null}
              {catalogueScreenDisplay === "catagories" && categoyrArray
                ? categoyrArray.map((item, index) => {
                    return item.categoryName
                      .toLowerCase()
                      .match(searchCatelgoue) ? (
                      <div
                        key={index}
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          minHeight: 45,
                          marginTop: 1,
                        }}
                      >
                        <CatalogueCategory
                          item={item}
                          productsArray={productsArray}
                          index={index}
                          selectedIndex={selectedIndex}
                          setSelectedProduct={setSelectedProduct}
                          setSelectedIndex={setSelectedIndex}
                          search={searchCatelgoue}
                        />
                        {/* <CatalogueListItem
                          productName={item.productName}
                          imageUrl={item.imageId}
                          category={item.category}
                          price={item.price}
                          createdBy={item.createdBy}
                          dateCreated={item.createdOn}
                          onViewClick={() => setSelectedProduct(item)}
                        /> */}
                      </div>
                    ) : null;
                  })
                : null}
            </div>
          </div>
        </div>
      ) : null}
      {/* // close buttons */}
      <div
        style={{
          position: "absolute",
          top: 20,
          left: 20,
          display: "flex",
          alignItems: "center",
        }}
      >
        <BaseButtons
          label={"BACK"}
          borderRadius={8}
          width={120}
          backgroundColor={colors.orangeDark}
          onClick={() => setSelectedAgency(null)}
        />
        <div style={{ fontSize: 18, fontWeight: "bold", marginLeft: 10 }}>
          AGENCY VIEW
        </div>
      </div>
      {/* // tab buttons */}
      <div
        style={{
          position: "absolute",
          top: 20,
          right: 20,
          display: "flex",
          alignItems: "center",
        }}
      >
        <BaseButtons
          label={"CATALOGUE"}
          // borderRadius={8}
          width={120}
          backgroundColor={
            displayScreen === "catalogue" ? colors.greenDark : colors.greenLight
          }
          onClick={() => setDisplayScreen("catalogue")}
        />
        {/* <div style={{ minWidth: 10 }} /> */}
        <BaseButtons
          label={"VEHICLE"}
          // borderRadius={8}
          width={120}
          backgroundColor={
            displayScreen === "vehicles" ? colors.greenDark : colors.greenLight
          }
          onClick={() => setDisplayScreen("vehicles")}
        />
        {/* <div style={{ minWidth: 10 }} /> */}
        <BaseButtons
          label={"PROFILE"}
          // borderRadius={8}
          width={120}
          backgroundColor={
            displayScreen === "profile" ? colors.greenDark : colors.greenLight
          }
          onClick={() => setDisplayScreen("profile")}
        />
        {/* <div style={{ minWidth: 10 }} /> */}
        <BaseButtons
          label={"TEAM"}
          // borderRadius={8}
          width={120}
          backgroundColor={
            displayScreen === "team" ? colors.greenDark : colors.greenLight
          }
          onClick={() => setDisplayScreen("team")}
        />
        {/* <div style={{ minWidth: 10 }} /> */}
        <BaseButtons
          label={"DOCUMENTS"}
          // borderRadius={8}
          width={120}
          backgroundColor={
            displayScreen === "documents" ? colors.greenDark : colors.greenLight
          }
          onClick={() => setDisplayScreen("documents")}
        />
        {/* <div style={{ minWidth: 10 }} /> */}
        <BaseButtons
          label={"CUSTOMERS"}
          // borderRadius={8}
          width={120}
          backgroundColor={
            displayScreen === "customers" ? colors.greenDark : colors.greenLight
          }
          onClick={() => {
            setDisplayScreen("customers");
          }}
        />
        {/* <div style={{ minWidth: 10 }} /> */}
        <BaseButtons
          label={"UPDATE"}
          // borderRadius={8}
          width={120}
          backgroundColor={colors.secondaryDarkBlue}
          onClick={() => EditAgency()}
          disabled={
            selectedAgency
              ? selectedAgency.accountStatus === statusCheck
                ? true
                : false
              : true
          }
        />
      </div>
      <CreateProductModal
        setMessage={setMessage}
        setPopUpTitle={setPopUpTitle}
        setLoading={setLoading}
        setToastPop={setToastPop}
        refresh={refresh}
        setRefresh={setRefresh}
        display={selectedProduct}
        setCreatePostModal={setSelectedProduct}
        auth={auth}
        companyInformation={selectedAgency}
        typeCheck={"edit"}
      />
    </div>
  );
};

export default AgencyManagerPopUp;
